/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledTitle = styled.h4`
    font-size: 22px;
    font-weight: 700;
`;
